<div class="text-align-center">
  <div class="card-body error-container">
    <mat-card-title *ngFor="let error of startupService.errors">
      {{ error | translate }}
    </mat-card-title>
  </div>
  <div>
    <div class="card-body">
      <mat-card-subtitle>
        {{ 'COMMON.consoleInfo' | translate }}</mat-card-subtitle
      >
    </div>
    <div>
      <button
        (click)="logout()"
        mat-menu-item
        class="user-info-logout"
        [title]="'COMMON.logout' | translate"
      >
        <mat-icon>logout</mat-icon>
        <span class="button-logout">{{ 'COMMON.logout' | translate }}</span>
      </button>
    </div>
  </div>
</div>
